import React from 'react';

interface QRCodePositionerProps {
  backgroundImage: string;
  qrCodeElement: React.ReactNode;
  position: number; // 0-8 pour les 9 positions possibles
  onPositionChange: (position: number) => void;
}

export const QRCodePositioner: React.FC<QRCodePositionerProps> = ({
  backgroundImage,
  qrCodeElement,
  onPositionChange,
  position,
}) => {
  // Créer une grille 3x3 de positions possibles
  const positions = Array(9).fill(null);

  return (
    <div className="relative w-full bg-gray-100 rounded-lg overflow-hidden">
      {/* Container pour maintenir le ratio */}
      <div className="w-full pb-[177.77%] relative">
        {/* Image de fond qui prend tout l'espace */}
        <img
          src={backgroundImage}
          alt="Background"
          className="absolute inset-0 w-full h-full object-cover"
        />
        
        {/* Container pour la grille qui limite le QR code dans les marges */}
        <div className="absolute inset-0 pointer-events-none">
          {/* Grille de positionnement */}
          <div className="relative w-full h-full grid grid-cols-3 grid-rows-3">
            {positions.map((_, index) => (
              <button
                key={index}
                onClick={() => onPositionChange(index)}
                className="relative pointer-events-auto group"
              >
                {/* Indicateur de position au survol */}
                <div className="absolute inset-0 border-2 border-dashed border-white/0 rounded-lg transition-all duration-200 group-hover:border-white/50" />
                
                {/* Indicateur de position */}
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100">
                  <div className="w-2 h-2 sm:w-3 sm:h-3 rounded-full bg-white/50 group-hover:bg-indigo-500/50" />
                </div>

                {position === index && (
                  <div className="absolute inset-0 flex items-center justify-center">
                    <div className="w-full h-full flex items-center justify-center">
                      {qrCodeElement}
                    </div>
                  </div>
                )}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
